import React from "react";
import { PlusIcon } from "@heroicons/react/24/solid";
import TooltipWrapper from "../../../common/TooltipWrapper";

interface NewDocumentButtonProps {
  documentType: string;
  onAddNewNote: () => void;
  disabled?: boolean;
  addDisabledMessage?: string;
  tooltipPosition?: 'bottom' | 'left';
}

export const NewDocumentButton: React.FC<NewDocumentButtonProps> = ({ 
  documentType, 
  onAddNewNote, 
  addDisabledMessage,
  disabled,
  tooltipPosition = 'bottom' 
}) => {
  const isDisabled = disabled || addDisabledMessage !== undefined;
  
  return (
    <TooltipWrapper showTooltip={isDisabled} content={addDisabledMessage} place={tooltipPosition}>
        <button
            className={`inline-flex items-center gap-x-1 py-2 px-3 text-sm font-medium ${isDisabled ? "text-gray-400 cursor-not-allowed" : "text-gray-500 hover:text-main"} transition-colors duration-200 ease-in-out rounded-md whitespace-nowrap`}
            onClick={onAddNewNote}
            disabled={isDisabled}
            aria-label={`Add new ${documentType.toLowerCase()}`}
        >
            <PlusIcon className="h-5 w-5" />
            <span>New {documentType.toLowerCase()}</span>
        </button>
    </TooltipWrapper>
  );
};